import React from 'react';

import { Link } from 'react-router-dom';

import { Icon } from '@tf/ui';

export const RefLink: React.FC<{ to: string }> = ({ to }) => {
	return (
		<Link to={to} style={{ verticalAlign: 'middle', marginLeft: '2px' }}>
			<Icon.IconExternalLink size={14} />
		</Link>
	);
};
